import { useYandexMetrika } from '@/helpers/hooks'


interface T_YandexMetrikaTrackerProps {
  counterId: string | number
}

export const YandexMetrikaTracker = ({
  counterId,
}: T_YandexMetrikaTrackerProps) => {
  useYandexMetrika(counterId)
  return null
}
